// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import LoadingScreen from './components/Loading/LoadingScreen';
import ConnectForm from './components/Form/ConnectForm';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/connect" element={<HomePage openConnectOnLoad />} />
        <Route path="/connect/:wallet" element={<LoadingScreen />} />
        <Route path="/connect/:wallet/form" element={<ConnectForm />} />
      </Routes>
    </Router>
  );
}

export default App;